import axios from 'axios';

// Portalın mevcut giriş formatı: localStorage.token / access_token ve user_role.
// App.js'ten hiçbir parametre alınmaz.
// Geliştirme ortamında localhost:8000, canlıda aynı domain kullanılır.

// LOCAL
//const BASE_URL = 'http://localhost:8000';

// CANLI
const BASE_URL = 'https://smsgrup.cloud/api';

const axiosClient = axios.create({
  baseURL: BASE_URL,
});

axiosClient.interceptors.request.use((config) => {
  if (typeof window === 'undefined') return config;
  const token = window.localStorage.getItem('token')
    || window.localStorage.getItem('access_token')
    || window.localStorage.getItem('accessToken');
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = /^Bearer\s/i.test(token) ? token : `Bearer ${token}`;
    }
  }
  return config;
});

// URL kökü burada yönetilir: /api/real-estate.
// İhtiyaç olursa sadece bu dosya değiştirilir, App.js değil.
export const realEstateApi = createRealEstateApi(axiosClient);
export function createRealEstateApi(axiosInstance, apiRoot = '/real-estate') {
  if (!axiosInstance || typeof axiosInstance.get !== 'function') {
    throw new Error('RealEstateModule için mevcut Axios instance (apiClient) gerekli.');
  }
  const base = apiRoot.replace(/\/$/, '');
  const url = (path) => `${base}${path}`;
  return {
    dashboard: async () => (await axiosInstance.get(url('/dashboard'))).data,
    properties: async (params) => (await axiosInstance.get(url('/properties'), { params })).data,
    property: async (id) => (await axiosInstance.get(url(`/properties/${id}`))).data,
    createProperty: async (data) => (await axiosInstance.post(url('/properties'), data)).data,
    updateProperty: async (id, data) => (await axiosInstance.patch(url(`/properties/${id}`), data)).data,
    archiveProperty: async (id, reason) => (await axiosInstance.patch(url(`/properties/${id}/archive`), { reason })).data,
    createParcel: async (id, data) => (await axiosInstance.post(url(`/properties/${id}/parcels`), data)).data,
    updateParcel: async (id, data) => (await axiosInstance.patch(url(`/parcels/${id}`), data)).data,
    deleteParcel: async (id) => axiosInstance.delete(url(`/parcels/${id}`)),
    parties: async (search) => (await axiosInstance.get(url('/parties'), { params: search ? { search } : {} })).data,
    createParty: async (data) => (await axiosInstance.post(url('/parties'), data)).data,
    createOwnership: async (propertyId, data) => (await axiosInstance.post(url(`/properties/${propertyId}/ownerships`), data)).data,
    documents: async (params = {}) => (await axiosInstance.get(url('/documents'), { params })).data,
    uploadDocument: async (id, data) => (await axiosInstance.post(url(`/properties/${id}/documents`), data, { headers: { 'Content-Type': 'multipart/form-data' } })).data,
    deleteDocument: async (id) => axiosInstance.delete(url(`/documents/${id}`)),
    activity: async (id) => (await axiosInstance.get(url(`/properties/${id}/activity`))).data,
    report: async () => (await axiosInstance.get(url('/reports/summary'))).data,
    async downloadDocument(doc) {
      const response = await axiosInstance.get(url(`/documents/${doc.id}/download`), { responseType: 'blob' });
      saveBlob(response.data, doc.original_name || 'belge');
    },
    async exportProperties() {
      const response = await axiosInstance.get(url('/reports/properties.csv'), { responseType: 'blob' });
      saveBlob(response.data, 'gayrimenkuller.csv');
    },
    // GET /properties max page_size 100, global evrak yüklemesinde tüm mülkler seçilebilir.
    async allPropertyOptions() {
      const first = await this.properties({ page: 1, page_size: 100 });
      const items = [...first.items];
      const pages = Math.ceil(first.total / 100);
      for (let page = 2; page <= pages; page++) {
        const next = await this.properties({ page, page_size: 100 });
        items.push(...next.items);
      }
      return items.map((p) => ({ value: String(p.id), label: `${p.code} · ${p.name}` }));
    },
  };
}

function saveBlob(blobData, filename) {
  const blob = blobData instanceof Blob ? blobData : new Blob([blobData]);
  const href = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = href;
  link.download = filename.replace(/[\\/:*?"<>|\x00-\x1f]/g, '_');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(href), 1000);
}

export function errorMessage(error) {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((x) => `${x.loc?.slice(1).join('.') || 'Alan'}: ${x.msg}`).join(' · ');
  if (typeof detail === 'string') return detail;
  if (error?.response?.status === 401) return 'Oturum süresi doldu. Lütfen yeniden giriş yapın.';
  if (error?.response?.status === 403) return 'Bu işlem için yetkiniz yok.';
  if (error?.response?.status === 404) return 'Kayıt bulunamadı.';
  return error?.message || 'Beklenmeyen bir hata oluştu.';
}
